<template>
  <div class="home-card" >
    <div class="bg" >
      <img src="/bg-icon.png" alt="">
    </div>
    <div class="msgs" >
      <div class="title" >公司理念</div>
      <div class="content" >致力于改变连锁企业系统过于厚重、不易复制、试错运维成本高的现状，为企业提供易学、易用、高性价比的数字化平台，帮助连锁企业快速拥抱互联网，赋能企业数字化、智慧化转型</div>
      <div class="tag" >轻便、智慧、开放、品牌、专注、未来</div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  methods: {

  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.home-card {
  height: calc(100vh - 60px);

  .bg {
    position: relative;
    height: calc(100vh - 60px - 200px);
    width: 100%;
    background-image: url(/public/bg.png);
    background-size: auto 100%;
    background-position: center center;
    background-repeat: no-repeat;

    img {
      width: 300px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    @media screen and (max-width: 500px) {
      height: calc(100vh - 60px - 160px);
    }
  }

  .msgs {
    height: 200px;
    color: #fff;
    background-color: #1d2029;
    padding: 40px 140px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      font-weight: 700;
      margin: 0 0 10px 0;

    }

    .content {
      margin: 0 0 10px 0;
    }

    .tag {
      font-weight: 700;
    }

    @media screen and (max-width: 500px) {
      padding: 20px 20px;
      height: 160px;


      .title {
        font-size: 15px;
        font-weight: 400;
      }

      .content {
        font-size: 12px;
      }

      .tag {
        font-size: 12px;
      }
    }
  }
}
</style>
